import { Environment } from '@src/environment';

export enum Paths {
  CALLBACK = '/callback', // evaluate if sample code is there. Redirect afterwarts to dashboard
  SILENT_CALLBACK = '/silent-callback', // target of the silent-renew iframe, never rendered to the user
  LOGIN = '/login', // with or without code
  REGISTER = '/register',
  LOGOUT = '/logout',
  CLAIM_SAMPLE = '/claimSample',
  SENDER_ADDRESS = '/senderAddress',
  SAMPLE_COMMENT = '/sampleComment',
  REGISTER_SAMPLE = '/sample',
  PROFILE = '/', // Account overview
  RESULT = '/result', // Result of test
  INTERNAL = '/internal', // Result of test
  GENERATE_SAMPLE_CODES = 'generateSampleCodes',
  REFRESH = 'refresh',
}

export const ExternalLinks = {
  EDIT_PROFILE_PAGE: `${Environment.OIDC_AUTHORITY}/account/manageAccount`,
  FOOTER_SHIPPING: 'https://www.wassertest-online.de/versandkosten.html',
  FOOTER_TEST_RESULT: 'https://www.wassertest-online.de/testergebnis.php',
  FOOTER_CONTACT: 'https://support.ivario.eu/de/support/tickets/new',
  FOOTER_DATA_PRIVACY:
    'https://www.wassertest-online.de/Datenschutzbestimmungen:_:2.html',
  FOOTER_IMPRINT: 'https://www.wassertest-online.de/Impressum:_:4.html',
  FOOTER_AGB: 'https://www.wassertest-online.de/Unsere-AGB:_:3.html',
  FOOTER_ACCREDITATION:
    'https://www.gba-group.com/gba-group/zertifizierungen-zulassungen/',
  FOOTER_BLOG: 'https://www.wassertest-online.de/blog/',
  FOOTER_FAQ: 'https://support.ivario.eu/de/support/home',
  FOOTER_TESTCOMPARE:
    'https://www.wassertest-online.de/testvergleichsseite.php?refID=tt',
  FOOTER_AFFILIATE: 'https://www.wassertest-online.de/affiliate-netzwerk.html',
  FOOTER_EXPERIENCE: 'https://ivario.com/de-de/pages/kundenbewertungen',
  FOOTER_WATER_WIKI: 'https://www.wassertest-online.de/trinkwasser-wiki/',
  FOOTER_MOLD_WIKI: 'https://www.wassertest-online.de/schimmel-wiki/',
  FOOTER_ASBESTOS: 'https://www.asbest-fachberater.de/',
  LEGACY_LOGIN: 'https://www.wassertest-online.de/login.php',
};
